import { render, staticRenderFns } from "./review-products.vue?vue&type=template&id=da9baafc&"
import script from "./review-products.vue?vue&type=script&lang=js&"
export * from "./review-products.vue?vue&type=script&lang=js&"
import style0 from "./review-products.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "review-products.vue"
export default component.exports